// @ts-strict-ignore
import React from 'react'
import { useTranslation } from 'react-i18next'
import { Box, DataListItem } from '@node-space/ui-components'
import { ellipseMiddleText } from '@node-space/utils'
import { SidePanelHeaderTemplateTwo } from 'components/SidePanel/SidePanelHeaderTemplates/SidePanelHeaderTemplateTwo'
import { NotificationDestination } from '../types'

interface DestinationSidePanelHeaderProps {
  destinationData: NotificationDestination
}

const DestinationSidePanelHeader = ({ destinationData }: DestinationSidePanelHeaderProps) => {
  const { t } = useTranslation()

  return (
    <SidePanelHeaderTemplateTwo
      heading={{
        iconUrls: null,
        primaryLabel: destinationData?.description,
        secondaryLabel: destinationData?.url,
      }}
    >
      <Box width="full">
        <DataListItem
          id={destinationData?.type}
          title={t('integrations.type')}
          body={destinationData?.type}
          layout={'horizontal'}
        />
        <DataListItem
          id={destinationData?.publicKey}
          title={t('integrations.publicKey')}
          copyText={destinationData?.publicKey}
          body={ellipseMiddleText(destinationData?.publicKey, 35, 0)}
          layout={'horizontal'}
        />
      </Box>
    </SidePanelHeaderTemplateTwo>
  )
}

export default DestinationSidePanelHeader
